import React, { Component } from "react";
import { Button, Icon, Divider } from "react-materialize";
import "./RegionSelection.styles.scss";
import { connect } from "react-redux";
const buttonList = [
  {
    icon: "public",
    lable: "Manage Circle",
    id: "clusters",
    createId: "circle",
    parent: null,
    parentId: "clusters",
    createParentId: "clusters",
    children: "regions",
    childrenPlaceHolder: "Zone(s)",
    parentPlaceHolder: null,
  },
  {
    icon: "public",
    lable: "Manage Zone",
    id: "regions",
    createId: "zone",
    parent: "cluster_name",
    parentId: "clusters",
    createParentId: "clusters",
    children: "areas",
    childrenPlaceHolder: "Area(s)",
    parentPlaceHolder: "Circle",
  },
  {
    icon: "terrain",
    lable: "Manage Area",
    id: "areas",
    createId: "area",
    parent: "region_name",
    parentId: "regions",
    createParentId: "region",
    children: "territories",
    childrenPlaceHolder: "Territory(s)",
    parentPlaceHolder: "Zone",
  },
  {
    icon: "map",
    lable: "Manage Territory",
    id: "territories",
    createId: "territory",
    parent: "area_name",
    parentId: "areas",
    createParentId: "area",
    children: "agencies",
    childrenPlaceHolder: "Distributor(s)",
    parentPlaceHolder: "Area",
  },
  {
    icon: "home",
    lable: "Manage Distributor",
    id: "agency",
    createId: "distributor",
    parent: "territory_name",
    parentId: "territories",
    createParentId: "territory",
    children: "spots",
    childrenPlaceHolder: "Spot(s)",
    parentPlaceHolder: "Territory",
  },
  {
    icon: "gps_fixed",
    lable: "Manage Spot",
    id: "spots",
    createId: "spot",
    parent: "agency_name",
    parentId: "agency",
    createParentId: "agency",
    children: null,
    parentPlaceHolder: "Distributor",
  },
];

class RegionSelectionBelt extends Component {
  constructor() {
    super();
    this.state = {
      currentButton: "spots",
    };
  }

  toggleButtons = (element) => {
    this.setState({ currentButton: element.id });
    this.props.callBack(element);
  };
  render() {
    return (
      <div className="region-management">
        <div className="region-buttons-container">
          <div className="buttons-group">
            {buttonList.map((element, index) => (
              <Button
                key={`${index}_${element.lable}`}
                className={`im-btn ${
                  this.state.currentButton === element.id
                    ? `active`
                    : `inactive`
                }`}
                onClick={() => this.toggleButtons(element)}
              >
                <Icon left large>
                  {element.icon}
                </Icon>
                <p>{element.lable}</p>
              </Button>
            ))}
          </div>
        </div>

        <Divider />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  changeTo: () => dispatch(() => {}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionSelectionBelt);
